import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const OtpInput = ({ value, onChange, onComplete, disabled, className, autoFocus = true }) => {
  const inputs = useRef([])

  useEffect(() => {
    if (autoFocus && inputs.current[0] && !disabled) {
      inputs.current[0].focus()
    }
  }, [])

  const handleChange = (e, index) => {
    const val = e.target.value
    if (isNaN(val)) return

    const newCode = value.split('')
    newCode[index] = val.substring(val.length - 1)
    const nextValue = newCode.join('')

    onChange(nextValue)

    if (val && index < 5 && inputs.current[index + 1]) {
      inputs.current[index + 1].focus()
    }

    if (nextValue.length === 6 && onComplete) {
      onComplete()
    }
  }

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace') {
      if (!value[index] && index > 0 && inputs.current[index - 1]) {
        inputs.current[index - 1].focus()
      }
    }
  }

  const handlePaste = e => {
    e.preventDefault()
    const pastedData = e.clipboardData.getData('text').slice(0, 6).replace(/\D/g, '')
    if (pastedData) {
      onChange(pastedData)
      const nextIndex = Math.min(pastedData.length, 5)
      if (inputs.current[nextIndex]) {
        inputs.current[nextIndex].focus()
      }
    }
  }

  return (
    <div className={clsx('flex gap-2 justify-between max-w-xs', className)}>
      {[0, 1, 2, 3, 4, 5].map(index => (
        <input
          key={index}
          ref={el => (inputs.current[index] = el)}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={value[index] || ''}
          onChange={e => handleChange(e, index)}
          onKeyDown={e => handleKeyDown(e, index)}
          onPaste={handlePaste}
          disabled={disabled}
          className={clsx(
            'w-10 h-12 text-center text-xl font-bold border-2 rounded focus:outline-none focus:border-yellow-500 bg-white shadow',
            disabled ? 'bg-gray-100 text-gray-400 border-gray-200' : 'border-gray-800'
          )}
        />
      ))}
    </div>
  )
}

OtpInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string
}

export default OtpInput
